import React from 'react';
import unitivaPictogram from '../../assets/logo-pictogram.svg';

import * as S from './style';

const Loader: React.FC = () => {
    return (
        <S.Loader>
            <div className="logo">
                <img src={unitivaPictogram} alt="Unitiva Logo"/>
            </div>
        </S.Loader>
    )
}

export default Loader;